import React, { useEffect, useRef, useState } from 'react';
import { apiFetch } from '../services/api';
import { Film } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Zeigt vor der ersten Intro-Lektion ein 4-12 Sekunden Sora-2 Cinematic-Video.
 * Fällt lautlos aus, wenn kein Video generiert wurde (`status !== 'ready'`).
 */
export const CourseIntroVideo = ({ moduleId }) => {
  const [state, setState] = useState({ loaded: false, url: null });
  const [dismissed, setDismissed] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (!moduleId) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await apiFetch(`${API}/api/video-intros/module/${moduleId}`);
        if (!res.ok) return;
        const data = await res.json();
        if (cancelled) return;
        if (data.status === 'ready' && data.video_url) {
          setState({ loaded: true, url: `${API}${data.video_url}` });
        }
      } catch {
        /* silent */
      }
    })();
    return () => { cancelled = true; };
  }, [moduleId]);

  if (!state.loaded || !state.url || dismissed) return null;

  return (
    <div
      data-testid="course-intro-video"
      className="mb-6 rounded-2xl overflow-hidden border border-yellow-500/30 bg-black shadow-lg shadow-yellow-500/10"
    >
      <div className="flex items-center justify-between px-4 py-2 bg-gradient-to-r from-yellow-500/10 to-transparent">
        <div className="flex items-center gap-2 text-yellow-400 text-sm font-medium">
          <Film className="w-4 h-4" />
          Kurs-Intro
        </div>
        <button
          data-testid="course-intro-skip-btn"
          onClick={() => setDismissed(true)}
          className="text-xs text-gray-400 hover:text-yellow-400 transition"
        >
          Überspringen →
        </button>
      </div>
      <video
        ref={videoRef}
        src={state.url}
        autoPlay
        muted
        playsInline
        controls
        onEnded={() => setDismissed(true)}
        className="w-full aspect-video bg-black"
      />
    </div>
  );
};

export default CourseIntroVideo;
